import { defineMessages } from 'react-intl';

export default defineMessages({
  unavailablePrice: {
    id: 'global_wm_unavailable_price',
    defaultMessage: 'On Request',
  },
});



// WEBPACK FOOTER //
// ./app/common/SnippetModal/messages.js